import Config from 'config'

export function state (storeListing) {
  storeListing.state.filters['temporary'] = {}
  storeListing.state.columnsView = Config.Theme.listingFilters.dropFilter.columnsView.selected
  storeListing.state.quickViewInstantSearch = false
  return storeListing.state
}
